if (!customElements.get("contact-inquiry-select")) {
  customElements.define(
    "contact-inquiry-select",
    class ContactInquirySelect extends HTMLElement {
      constructor() {
        super();
        this.syncTag = this.syncTag.bind(this);
      }

      connectedCallback() {
        this.select = this.querySelector("[data-inquiry-type-select]");
        this.tagsInput = this.querySelector("[data-inquiry-type-tags]");

        if (!this.select || !this.tagsInput) return;

        this.form = this.closest("form");

        this.select.addEventListener("change", this.syncTag);

        // `change` alone is not enough. Back/forward navigation, bfcache restore and
        // reload-autofill all reapply a <select>'s selection WITHOUT firing `change`,
        // and because this script is deferred the upgrade can run before the browser
        // reapplies that state. Syncing again at submit time is the one hook guaranteed
        // to observe the value actually being posted; `pageshow` keeps the hidden input
        // honest for anything that inspects it before submit.
        if (this.form) this.form.addEventListener("submit", this.syncTag);
        window.addEventListener("pageshow", this.syncTag);

        this.syncTag();
      }

      disconnectedCallback() {
        if (this.select) this.select.removeEventListener("change", this.syncTag);
        if (this.form) this.form.removeEventListener("submit", this.syncTag);
        window.removeEventListener("pageshow", this.syncTag);
      }

      syncTag() {
        if (!this.select || !this.tagsInput) return;

        const option = this.select.options[this.select.selectedIndex];
        const tag = option ? option.getAttribute("data-tag") || "" : "";

        this.tagsInput.value = tag;
        // A disabled control is never submitted, so "nothing chosen" posts no
        // contact[tags] param at all rather than an empty one. Under-tagging is
        // recoverable; mis-tagging silently is not.
        this.tagsInput.disabled = tag === "";
      }
    },
  );
}
